/**
 * title-editor.js
 */

import React from 'react';
import { TextField, Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useFormContext, useWatch, Controller } from 'react-hook-form';
import Button from 'components/button';
import EditButton from 'components/edit-button';


const useStyles = makeStyles(theme => ({
  root: {
    height: 40,
    '& .hide': {
      display: 'none'
    },
    '& .display': {
      cursor: props => props.disabled ? 'unset' : 'pointer',
      '& .MuiButtonBase-root': {
        color: theme.palette.primary.main,
        transition: '250ms ease-in-out',
        opacity: 0.7,
        '& .MuiSvgIcon-root': {
          fontSize: 20,
        },
      },
      '&:hover .MuiButtonBase-root': {
        opacity: 1
      }
    },
  },
}));


export default function TitleEditor(props) {
  const {
    propertyName,
    inputLabel,
    helperText,
    validationRules,
    disabled,
    editButtonTestId,
    saveButtonTestId,
  } = props;
  const classes = useStyles({ disabled });
  const formContext = useFormContext();
  const { control } = formContext;
  const title = useWatch({ control, name: propertyName });
  const [editingTitle, setEditingTitle] = React.useState();


  return (
    <>
      <div className={`flex-hc ${classes.root}`}>

        {/* DISPLAY */}
        <div 
          className={`flex-hc display ${editingTitle !== undefined ? 'hide' : ''}`} 
          onClick={() => {
            if (!disabled) {
              setEditingTitle(title);
            }
          }}
        >
          {title || <Box sx={{ opacity: 0.5 }}>{inputLabel}</Box>}
          {!disabled &&
          <EditButton 
            tooltip={`Edit ${inputLabel}`}
            iconOnly
            size='small'
            style={{ marginLeft: 8 }}
            data-testid={editButtonTestId}
          />}
        </div>

        {/* EDIT */}
        {!disabled &&
        <div className={`flex-hc edit ${editingTitle !== undefined ? '' : 'hide'}`}>
          <Controller 
            control={control}
            name={propertyName}
            defaultValue=''
            rules={validationRules}
            render={({ field }) => (
              editingTitle !== undefined &&
                <TextField
                  autoFocus
                  variant='outlined'
                  size='small'
                  sx={{ '& .MuiInputBase-root': { pr: 0 }}}
                  label={inputLabel}
                  helperText={helperText}
                  value={editingTitle || ''}
                  onChange={(e) => setEditingTitle(e.target.value)}
                  InputProps={{
                    inputProps: { 'data-testid': 'name-input' },
                    endAdornment: (
                      <Button 
                        data-testid={saveButtonTestId}
                        children='OK'
                        onClick={() => {
                          field.onChange(editingTitle);
                          setEditingTitle();
                        }}
                      />
                    ),
                    onFocus: e => e.currentTarget.select(),
                    onKeyDown: e => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        field.onChange(editingTitle);
                        setEditingTitle();
                      } else if (e.key === 'Escape') {
                        setEditingTitle();
                      }
                    }
                  }}
                />
              
            )}
          />
        </div>}

      </div>
    </>
  );
}